import React, { useState } from "react";
import { Icons, StarContainer } from "./style";

function RatingStars(props) {
  const [currentValue, setCurrentValue] = useState(0);
  const [hoverValue, setHoverValue] = useState(null);

  // const [color, setColor] = useState(props.color);

  const handleClick = (value) => {
    setCurrentValue(value);
  };

  const handleMouseOver = (value) => {
    setHoverValue(value);
  };
  const handleMouseLeave = (value) => {
    setHoverValue(null);
  };

  const stars = Array(5)
    .fill(0)
    .map((_, index) => {
      return (
        <Icons.StarsIcon
          className="ratingStars"
          alt=""
          key={index}
          color={(hoverValue || currentValue) > index ? props.color : "#bababa"}
          onClick={() => handleClick(index + 1)}
          onMouseOver={() => handleMouseOver(index + 1)}
          onMouseLeave={handleMouseLeave}
        />
      );
    });
  return <StarContainer>{stars}</StarContainer>;
}
export default RatingStars;

//
